import React, { PureComponent } from "react";
import { BackgroundImage } from "..";

export default class TipsTrendsItemGrid extends PureComponent {
  render() {
    const { image, date, title } = this.props;
    return (
      <div className="tips-trends-item grid">
        <div className="image">
          <BackgroundImage image={image} />
        </div>
        <div className="date">{date}</div>
        <div className="title">{title}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TipsTrendsItem/Grid.js